import { AdminAccountWebService } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: AdminAccountWebService.Configuration
});

export default config;
